export default "__VITE_ASSET__Cd$tAOHD__"